// extracted by mini-css-extract-plugin
module.exports = {"content":"advantages_content__yY_FQ","title":"advantages_title__fXlKX","advantages":"advantages_advantages__0GVzo"};